<template>
  <div class="page-content notification">
    <h1 class="page-title">{{ $locale('sideMenu.notification') }}</h1>
    <section class="notification-container">
      <el-row>
        <el-col :span="24" :xs="24">
          <template v-if="notiListData.length > 0">
            <div
              class="collapse-card"
              v-for="(list, idx) in notiListData"
              :key="`collapse-card-${idx}`"
            >
              <p class="card-title" :class="clzForStatus(list.deviceStatus)">{{ list.title }}</p>
              <p class="card-desp" :class="list.isExtend ? 'open' : ''">{{ list.content }}</p>
              <p class="card-time">{{ $moment(list.createTime).format("YYYY/MM/DD") }}</p>
              <a class="btn-extend" @click="extendAction(idx)">
                &nbsp;
                <i :class="list.isExtend ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
              </a>
            </div>

            <CommPagination
              :total="pagination.counts"
              :curPage="pagination.currentPage"
              :pageSize="pagination.pageSize"
              @current-change="choosePage"
            />
          </template>
          <div class="no-data-container" v-else>
            {{ $locale("global.noData") }}
          </div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex"; //mapState,mapGetters
import { getNotiListService } from "@/helpers/service/api/common";
import tranfResData from "@/utils/tranfResData";
import CommPagination from "@/components/common/CommPagination";
import { statusMapping } from "@/assets/js/notification";

export default {
  name: "Notification",
  components: {
    CommPagination,
  },
  data() {
    return {
      isLoading: true,
      notiListData: [],
      pagination: {
        counts: 0,
        currentPage: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
    }),
  },
  created() {
    this.getNotiList();
  },
  methods: {
    async getNotiList() {
      await getNotiListService({
        cinemaId: this.cinemaId,
        isPage: true, //param for pagination
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }).then(res => {
        if (res.success) {
          this.notiListData = res.data ? res.data.data || [] : [];
          this.pagination.counts = res.data ? res.data.count : 0;
          this.assembleDataFn();
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    assembleDataFn() {
      if (this.notiListData.length === 0) { return; }

      const _notiList = tranfResData(this.notiListData);
      _notiList.forEach(_list => {
        _list.isExtend = false;
      });
      this.notiListData = _notiList;
    },
    extendAction(_idx) {
      if (this.notiListData[_idx]) {
        this.notiListData[_idx].isExtend = !this.notiListData[_idx].isExtend;
      }
    },
    clzForStatus(_status) {
      return statusMapping[_status] || "offline";
    },
    choosePage(page) {
      this.pagination = {
        ...this.pagination,
        currentPage: page - 1,
      };

      this.getNotiList();
    },
  },
};
</script>

<style scoped lang="less">
  .notification-container {
    margin: 20px;

    p {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .collapse-card {
      position: relative;

      .card-title {
        position: relative;
        padding-right: 20px;
        font-size: 1.1rem;
        font-weight: 600;

        &::after {
          content: "";
          position: absolute;
          right: 5px;
          top: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: @primary-green;
        }

        &.offline {
          &::after {
            background-color: @primary-dark-grey;
          }
        }

        &.disconnect {
          &::after {
            background-color: @primary-red;
          }
        }
      }

      .card-desp,
      .card-time {
        font-size: 1rem;
      }

      .card-desp {
        margin-right: 50px;
        line-height: 24px;
        max-height: 48px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        transition-duration: 200ms;

        &.open {
          display: block;
          max-height: none;
          overflow: auto;
        }
      }

      .card-time {
        color: @primary-dark-grey;
      }

      .btn-extend {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 0;
        top: 50px;

        > i {
          font-size: 1.4rem;
          font-weight: 600;
          color: @primary-orange;
        }

        &:hover {
          > i {
            color: @deep-orange;
          }
        }
      }
    }

    .collapse-card + .collapse-card {
      margin-top: 20px;
      border-top: 1px solid #e3e3e3;
    }

    .no-data-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      margin-top: 20%;
      font-size: 1.2rem;
      color: @primary-dark-grey;
      text-align: center;
    }
  }
</style>
